// extracted by mini-css-extract-plugin
module.exports = {"remark-div":"remark-div-452168f8f4e81c766f302c4f23cb9294"};